/// <reference path="./Tag.ts" />
/// <reference path="./Span.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Dynamic extends Div {
        private static guessContentType(data: Map<any, any> | any) {
            if (!(data instanceof Map) || !data.get("c")) {
                return null;
            }
            const c = data.get("c");
            if (!(c instanceof Map) || !(typeof (c.get("0")) === "object")) {
                return null;
            }
            const first = toMap(c.get("0"));

            return first.get("t");
        }

        /**
         *
         * @returns {string}
         */
        public getTagName() {
            return this.get("_tname");
        }

        /**
         * @param data
         */
        protected initialize(data: any) {
            const ctype = Dynamic.guessContentType(data);
            if (!ctype) {
                if (data instanceof Map) {
                    data.set("_tname", "span");
                }
                super.initialize(data);
                this.addClass("tf");
                return;
            }
            data.set("_tname", "div");

            super.initialize(data);
        }
    }
}